module.exports = __webpack_public_path__ + "img/pass.fbd8c4cb.png";